<template>
  <div id="app">
    <a-modal
      :title="modal.title"
      :visible="modal.show"
      @ok="$store.dispatch('CONFIRM_MODAL')"
      :confirmLoading="modal.load"
      @cancel="$store.commit('CLOSE_MODAL')"
      >
      <p>{{modal.text}}</p>
    </a-modal>
    <MediaSelector />
    <Intro />
    <SetRule />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaSelector from 'bh-mod/components/file/MediaSelector'
import Intro from '@/components/siteplan/Intro'
import SetRule from '@/components/siteplan/SetRule'
export default {
  name: 'app',
  components: { MediaSelector,Intro,SetRule },
  computed: {
    ...mapGetters(['user']),
    modal(){
      return this.$store.state.siteplan.modal
    }
  },
  watch: {
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  methods:{

  }
}
</script>
<style>
  #app{
    min-height: 100vh;
  }
  .wcp-editor-toolbar-button.wcp-active{
    background:var(--primary);
  }
  .wcp-editor-toolbar-button-icon{
    display:flex;
    align-items: center;
  }
  .wcp-editor-tooltip-right .wcp-editor-tooltip-visible{
    background:#3F3356;
  }
</style>